<template>
    <div>
        <b-card
            :header="store?store.title:``"
            header-tag="header">
            <div class="row">
                <div class="col-12" v-if="!os">
                    <h4>Thanks for your order</h4>
                    <p>{{ orderResult.result }}, order #{{ orderResult.orderNumber }}, your order will be ready in {{ orderResult.waitTime }} minutes.</p>
                </div>
                <div class="col-12" v-if="os">
                    <h5 class="float-left">Order Number</h5><h5 class="float-right"><b>#{{os.orderNumber}}</b></h5><br>
                </div>
                <div class="col-12" v-if="os">
                    <div class="row my-1">
                        <div class="col-12">
                            <div v-if="!(isRejected || isCancelledStaff || isCancelledCustomer)">
                                <div class="d-flex justify-content-between progressbar">
                                    <div class="text-center step">
                                        <img src="@/assets/images/confirmed-icon.png" v-if="orderProgress > 0" />
                                        <img src="@/assets/images/confirmed-gray-icon.png" v-else/>
                                        <p class="text-dark">Accepted</p>
                                    </div>
                                    <div class="divider"/>
                                    <div class="text-center step">
                                        <img src="@/assets/images/preparing-icon.png"  v-if="orderProgress > 33"/>
                                        <img src="@/assets/images/preparing-gray-icon.png"  v-else/>
                                        <p class="text-dark">Preparing</p>
                                    </div>
                                    <div class="divider"/>
                                    <div class="text-center step">
                                        <img src="@/assets/images/ready-icon.png" v-if="orderProgress === 100"/>
                                        <img src="@/assets/images/ready-gray-icon.png" v-else/>
                                        <p class="text-dark">Ready</p>
                                    </div>
                                </div>
                                <b-progress v-if="!(isRejected || isCancelledStaff || isCancelledCustomer)" 
                                            class="my-3" 
                                            :value="orderProgress"
                                            max="100" 
                                            variant="success" 
                                            striped 
                                            animated />
                                <h5 class="text-center my-1 text-primary" >{{pick_status}}</h5>
                                <h6 class="text-center my-1">{{stsMsg}}</h6>
                            </div>
                            <div class="progressbar" v-else-if="isRejected">
                                <img src="@/assets/images/rejected-icon.png" class="float-left m-2"/>
                                <h5 class="my-1 pt-3">{{pick_status}}</h5>
                                <br/>
                                <h6 class="my-2">{{stsMsg}}</h6>
                            </div>
                            <div class="progressbar" v-else-if="isCancelledStaff || isCancelledCustomer">
                                <img src="@/assets/images/cancelled-icon.png" class="float-left m-2"/>
                                <h5 class="my-1 pt-3">{{pick_status}}</h5>
                                <br/>
                                <h6 class="my-2">{{stsMsg}}</h6>
                            </div>
                            <div v-if="false && iamHere && isPreparing && os.location.iAmHereEnabled" class="text-center my-1">
                                <h6>Please let us know when you arrive to pick up your order</h6>
                                <img
                                    class="iamhere can_click" 
                                    src="@/assets/images/iamhere.svg"
                                    @click="i_am_here"/>
                            </div> 
                        </div>                            
                    </div>                        
                </div>
                <div class="col-12 mt-2">
                    <store-info :hasTitle="false" />
                </div>
                <div class="col-12" v-if="os">
                    <button class="btn btn-link float-left"
                            v-if="isNew && (os.location !== null && os.location.allowCancel)" 
                            @click="cancel_order">Cancel My Order</button>

                    <button class="btn btn-link float-right"    
                            v-if="isRejected || isCancelledCustomer || isCancelledStaff || isReady || isClosed"
                            @click="new_order">New Order</button>                                 
                    
                    <button class="btn btn-link float-right"
                            v-if="false"
                            @click="cancel_order">View Receipt</button>                                            
                </div>                                           
            </div> 
        </b-card>                      
    </div>
</template>
<script>
import StoreInfo from '@/components/menu/StoreInfo'
import * as Ably from "ably";
import moment from 'moment'
import {mapState} from 'vuex'

export default {
    name: 'StatusOrder',
    props:{
        orderResult:{type:Object}
    },
    watch: {
        ablyKey(){
            this.startAbly()
        },
        orderResult () {
            this.get_order_status()           
        },
        os:{
            deep:true,
            handler(){
                this.$emit('os',this.os)               
            }
        }
    },
    components: {
        StoreInfo
    },
    data() {
      return {  
                orderProgress:0,
                iamHere: true,
                os:null,
                pick_status:"", 
                stsMsg:"", 
                ably:null, 
                channel:null,
                eventName:"visibilitychange"
            }
    },
    computed: {
        ...mapState({
            ablyKey: 'ablyKey',
            store: 'store',
            userInfo: 'userInfo'
        }),
        isNew() {            
            return this.os!=null && this.os.status==='New'
        },
        isConfirmed(){
            return this.os!=null && this.os.status==='Confirmed'
        },
        isPreparing(){
            return this.os!=null && this.os.status==='Preparing'
        },
        isPack(){
            return this.os!=null && this.os.status==='Pack'
        }        ,
        isReady(){
            return this.os!=null && this.os.status==='Ready'
        },
        isClosed(){
            return this.os!=null && this.os.status==='Closed'
        },
        isRejected(){
            return this.os!=null && this.os.status==='Rejected'
        },
        isCancelledCustomer(){
            return  this.os!=null && this.os.status==='Cancelled_Customer'
        },
        isCancelledStaff(){
            return  this.os!=null && this.os.status==='Cancelled_Staff'
        }
    },
    methods:{           
        get_order_status() {
            if(this.orderResult === null || this.orderResult._id === undefined){
                return
            }
            this.$store
            .dispatch('orderStatus', this.orderResult)
            .then(r => {
                  this.os = r
                  this.order_status_msg()
                  this.startAbly()                  
            }).catch(e => {
                console.log(e);
                this.os  = null;
            })
        },
        order_status_msg() {            
            this.pick_status = ""
            this.stsMsg = ""        
            if(this.isNew){

                this.orderProgress = 0
                this.pick_status = "Waiting for order confirmation."
                this.stsMsg = ""

            }else if(this.isConfirmed){

                this.orderProgress = 33
                this.pick_status = "Accepted"
                this.stsMsg = `Estimated pick up : ${moment(this.os.timeEstimate).format("hh:mm a")}`

            }else if(this.isPreparing){

                this.orderProgress = 66
                this.pick_status = "Preparing"
                this.stsMsg = `Estimated pick up : ${moment(this.os.timeEstimate).format("hh:mm a")}`

            }else if(this.isPack){

                this.orderProgress = 80
                this.pick_status = "Packing"
                this.stsMsg = ""                

            }else if(this.isReady){

                this.orderProgress = 100
                this.pick_status = "Ready For Pickup!"
                this.stsMsg = ""                

            }else if(this.isClosed){

                this.orderProgress = 100
                this.pick_status = "Order Closed. Thank you"
                this.stsMsg = ""                

            }else if(this.isRejected){

                this.orderProgress = 0
                this.pick_status = "Not Accepted"
                this.stsMsg = "We are sorry, but we are too busy to accept your order now. Your payment has been returned"       

            }else if(this.isCancelledCustomer){

                this.orderProgress = 0
                this.pick_status = "Order Cancelled"
                this.stsMsg = "You have cancelled your order. Your payment has been returned"       

            }else if(this.isCancelledStaff){

                this.orderProgress = 0
                this.pick_status = "Order Cancelled"
                this.stsMsg = "We are sorry. Your Order has been cancelled. Your payment has been returned"       

            }
        },
        cancel_order(){
            this.$store
            .dispatch('customerCancel', this.orderResult)
            .then(r => {  this.os = r })
            .catch(e => {console.log(e)})
        },
        new_order(){
            this.$store.dispatch('new_order')
            this.$router.push({name: "Home"}).catch(()=>{});
        },
        i_am_here() {
            this.$store
            .dispatch('iAmHere', this.orderResult)
            .then(() => { 
                this.iamHere = false
            })
            .catch(e => {console.log(e)})
        },
        startAbly() {
            let channelName = this.os ? this.os.location._id : ""

            if (!this.ablyKey || !channelName || this.ably !== null){
                console.log("isAblyKeyEmpty -> ",this.ablyKey, channelName)
                return
            } 

            console.log("ably channel name",channelName)
            this.ably = new Ably.Realtime(this.ablyKey);
            this.channel = this.ably.channels.get(channelName);
            // Subscribe to messages on channel
            let self = this
            this.channel.subscribe('orderStatus', function(message) {
                if (message.data._id === self.os._id) {
                    for (var property in message.data) {
                        try{
                            if((property !== 'orderStatus') &&
                                (self.os[property] !== message.data[property])){
                                console.log(property , self.os[property] + " " + message.data[property])    
                                self.os[property] = message.data[property]
                            }
                        }catch(e){
                            console.log("OrderResult Stats from Ably "+ e);
                        }
                    }
                  self.order_status_msg()
                }
            });
        },        
        visibilityChanged(){
            if (document.hidden || document.mozHidden || document.msHidden || document.webkitHidden) {
                console.log("Page Hidden")
            } else {
                this.get_order_status() 
                console.log("Page Shown")
            }           
        }
    },
    created(){ 
       this.get_order_status()
        if (document.webkitHidden != undefined) {
            this.eventName = "webkitvisibilitychange";
        } else if (document.mozHidden != undefined) {
            this.eventName = "mozvisibilitychange";
        } else if (document.msHidden != undefined) {
            this.eventName = "msvisibilitychange";
        } 
        window.addEventListener(this.eventName, this.visibilityChanged, false)
    },
    destroyed() {
        window.removeEventListener(this.eventName, this.visibilityChanged)        
    },
    mounted(){
        this.$nextTick(()=> {
            
        })        
    }
}
</script>
<style scoped>
.divider{
    width: 100%;
    height:3px;
    margin-top:20px;
    background: #cbcbcb;
}
.progressbar img{
    height: 40px;
    width: 40px;
}
.progressbar p{
    margin: 0px !important;
    /* font-size: 10px; */
}
.iamhere{
    width:100px;
    height:100px;
}
.can_click:hover {
    cursor: pointer;
}
.my-fit-content{
    width: fit-content;
}

</style>